import { MediaMeta, MediaType } from "@/pages/mediaManager";
import { Button, Center, Image, Input, Text } from "@chakra-ui/react";
import { faCancel, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { v4 } from "uuid";

const ImageChecker: React.FC<{
	onAdd: (newMedia: MediaMeta, file: File, icon?: File) => void,
	currentImage: File,
	onValidate: (newMedia: MediaMeta) => string | undefined
}> = ({ onAdd, currentImage, onValidate }) => {
	const [invalid, setInvalid] = useState<string>()

	function makeNewIconMeta(): MediaMeta {
		const id = v4()
		return {
			id: `${id}${currentImage.name.slice(currentImage.name.lastIndexOf("."))}`,
			iconId: `${id}${currentImage.name.slice(currentImage.name.lastIndexOf("."))}`,
			type: MediaType.Image,
			name: currentImage.name.slice(0, currentImage.name.lastIndexOf('.')),
			fileUrl: URL.createObjectURL(currentImage),
			iconUrl: URL.createObjectURL(currentImage),
			references: [],
			uploaded: new Date(),
			size: currentImage.size
		}
	}
	const [newMedia, setNewMedia] = useState<MediaMeta>(makeNewIconMeta())

	useEffect(() => {
		setNewMedia(makeNewIconMeta)
	}, [currentImage])

	useEffect(() => {
		setInvalid(onValidate(newMedia))
	}, [newMedia])

	return (
		<Center flexDir='column' gap={3}>
			<Image src={URL.createObjectURL(currentImage)} w='100%' flex={1} objectFit='contain' maxH='60vh' />
			<Center gap={3} paddingY={3}>
				<Text as='b' w={195}> Item Name: </Text>
				<Input
					placeholder="Item Name"
					value={newMedia.name}
					onChange={(e) => setNewMedia({ ...newMedia, name: e.target.value })}
				/>
			</Center>
			<Center paddingY={3} gap={3} w='100%'>
				{invalid ? (
					<Button leftIcon={<FontAwesomeIcon icon={faCancel} />} flex={1} isDisabled>{invalid}</Button>
				) : (
					<Button leftIcon={<FontAwesomeIcon icon={faUpload} />} flex={1} onClick={() => onAdd(newMedia, currentImage, currentImage)}>Upload Image</Button>
				)}
			</Center>
		</Center>
	)
}

export default ImageChecker
